<div class="page container" [class.h-100]="fullHeight()">
  <div class="wrapper py-2" [class.h-100]="fullHeight()">
    <div class="inner" appScrollVisible>
      <ng-content></ng-content>
    </div>
  </div>
</div>
